export const getDefault = () => {
  const schema = {
    name: 'OneFact',
    hasLink: true,
    backgroundColor: '#404041',
    textColor: '#FFF',
    isThemeReverse: true,
    data: [
      '17k',
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.'
    ]
  }
  return schema
}
